// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  paymentId: __t.string(),
  accountId: __t.string(),
  telegramUserId: __t.string(),
  starsAmount: __t.u32(),
  elmAmount: __t.u32(),
  telegramPaymentChargeId: __t.string(),
  invoicePayload: __t.string(),
};
